export enum SPACES {
  FASTLANE = 'fastlane',
  CORE = 'core',
  PRIVACY_HUB = 'privacyhub',
  LEGACY = 'legacy',
  PRICING = 'pricing',
}
